<template>
	<div>
		<basic-container>
			<el-form :model="searchForm" ref="searchFormRef" label-suffix=":" label-width="100px"
				v-show="searchBoxFlag">
				<el-row :gutter="24">
					<el-col :span="6">
						<el-form-item label="项目名称" prop="projectId">
							<el-select v-model="searchForm.projectId" style="width:100%" placeholder="请选择"
								@change="projectIdChange">
								<el-option v-for="item in projectList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="区域编号" prop="checkPass">
							<el-input clearable v-model="searchForm.code" placeholder="区域编号" maxlength="20"></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="6">
						<el-form-item label="区域名称" prop="checkPass">
							<el-input clearable v-model="searchForm.areaName" placeholder="区域名称"
								maxlength="20"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="区域全称" prop="objectType">
							<el-input clearable v-model="searchForm.fullName" placeholder="区域全称"
								maxlength="20"></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="6">
						<el-form-item label="所属部门" prop="deptId">
							<avue-input-tree :disabled="deptNameFlag" style="width:100%" :props="treeDeptProps"
								v-model="searchForm.deptId" placeholder="所属部门" type="tree"
								:dic="deptList"></avue-input-tree>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="巡查类型" prop="areaId">
							<el-select v-model="searchForm.inspectType" placeholder="巡查类型" style="width:100%" clearable>
								<el-option v-for="item in inspectTypeList" :key="item.dictKey" :label="item.dictValue"
									:value="item.dictKey">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="巡检日期">
							<el-date-picker style="width: 100%" clearable v-model="searchForm.timeRange"
								value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期"
								end-placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="标准名称" prop="checkPass">
							<el-input clearable v-model="searchForm.standardName" placeholder="标准名称"
								maxlength="20"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="巡检人" prop="checkPass">
							<el-input clearable v-model="searchForm.realInspectManName" placeholder="巡检人"
								maxlength="20"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="巡检结果" prop="projectId">
							<el-select v-model="searchForm.errorFlag" style="width:100%" placeholder="巡检结果" clearable>
								<el-option label="正常" value="0"> </el-option>
								<el-option label="异常" value="1"> </el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<div style="float:right">
							<el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
								搜索
							</el-button>
							<el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
						</div>
					</el-col>
				</el-row>
			</el-form>
			<avue-crud :option="option" :table-loading="loading" :data="data" :page.sync="page" ref="crud"
				@on-load="onLoad" @selection-change="selectionChange" @current-change="currentChange"
				@size-change="sizeChange" @refresh-change="onLoad">
				<template slot="menuLeft">
					<el-button type="primary" icon="el-icon-plus" size="small" @click="addRecord">
						新 增</el-button>
					<!-- <el-button type="primary" icon="el-icon-plus" size="small" @click="delConstractInvoice">删除</el-button> -->
				</template>
				<template slot="inspectTypeName" slot-scope="scope">
					<span>{{ returnInspectTypeName(scope.row.inspectType) }}</span>
				</template>
				<template slot="menuRight">
					<searchFromShow :searchBoxFlag.sync="searchBoxFlag" :removeHeight="searchHeight" :option="option"
						:refOption="$refs.crud"></searchFromShow>
				</template>
				<template slot="menuLeft">
					<wq-exportData :moduleType="701" @exportExcel="exportExcel"></wq-exportData>
				</template>
				<template slot-scope="scope" slot="menu">
					<el-button type="text" size="small" icon="el-icon-tickets" @click="checkRecord(scope.row)">查看
					</el-button>
					<el-button type="text" size="small" icon="el-icon-edit" @click="editRecord(scope.row)">编辑
					</el-button>
					<el-button type="text" size="small" icon="el-icon-delete" @click="removeRecord(scope.row.id)">删除
					</el-button>
				</template>
			</avue-crud>
		</basic-container>

		<hr-dialog :title="recordTittle" :allowFull="false" width="60%" :visible.sync="visible">
			<template slot="body">
				<RecordForm v-if="visible" :row="row" :model="recordModel" @submitOver="submitOver"
					@cancelOperate="recordFormClose"></RecordForm>
			</template>
		</hr-dialog>
	</div>
</template>

<script>
import { getProjectList } from '@/api/crmedical/project/project';

import { treeByProjectDeptId } from '@/api/crmedical/device/device';

import searchFromShow from '@/components/search-form-show/index';
import { getToken } from '@/util/auth';

import {
	getDictionary,
	getBisDictData,
	taskListPage,
	taskGeneralDetail,
	taskGeneralRemove,
} from '@/api/crmedical/comprehensiveInspect/index.js';
import RecordForm from './recordForm.vue';
export default {
	components: {
		searchFromShow,
		RecordForm,
	},
	data() {
		return {
			recordTittle: '新增',
			recordModel: 'add',
			exportForm: {},
			row: {
				attachList: [],
				errorFlag: '',
				realInspectTime: '',
				realInspectManId: '',
				areaId: '',
				realInspectManName: '',
				code: '',
				areaName: '',
				fullName: '',
				inspectType: '',
				deptId: '',
				startTime: '',
				endTime: '',
				description: '',
			},
			searchBoxFlag: true,
			searchHeight: '',
			isWatch: false,
			areaIdFlag: true,
			deptIdFlag: true,
			objectTypeFlag: true,
			showDetpTree: false,
			addOrEditFlag: false,
			dialogTitle: '新增',
			isEdit: true,
			data: [],
			form: {
				projectId: '',
				attachList: [],
			},
			contractIds: '',
			searchForm: {
				projectId: '',
				code: '',
				areaName: '',
				fullName: '',
				inspectType: '',
				deptId: '',
				deptName: '',
				typeId: '',
				typeName: '',
				startTime: '',
				endTime: '',
				errorFlag:'',
				realInspectManName:'',
				standardName:'',
				timeRange: [],
			},
			treeDeptProps: {
				labelText: '标题',
				label: 'title',
				value: 'id',
				children: 'children',
			},
			deptList: [],
			areaList: [],
			option: {
				index: true,
				indexLabel: '#',
				page: true,
				height: 'auto',
				calcHeight: 'auto',
				align: 'left',
				menu: true,
				addBtn: false,
				editBtn: false,
				selection: true,
				delBtn: false,
				border: true,
				column: [
					{
						label: '项目名称',
						prop: 'projectName',
					},

					{
						label: '区域编号',
						prop: 'code',
					},
					{
						label: '区域名称',
						prop: 'areaName',
					},
					{
						label: '区域全称',
						prop: 'fullName',
					},

					{
						label: '所属部门',
						prop: 'deptName',
					},
					{
						label: '巡查类型',
						prop: 'inspectTypeName',
						slot: true,
					},
					{
						label: '标准名称',
						prop: 'standardName',
					},
					{
						label: '巡查人',
						prop: 'realInspectManName',
					},
					{
						label: '巡检时间',
						prop: 'realInspectTime',
						format: 'yyyy-MM-dd HH:mm:ss',
						type: 'date',
					},
					{
						label: '巡检结果',
						prop: 'errorFlag',
						dicData: [
							{ name: '正常', errorFlag: '0' },
							{ name: '异常', errorFlag: '1' },
						],
						props: {
							value: 'errorFlag',
							label: 'name',
						},
					},
					{
						label: '工单编号',
						prop: 'orderCode',
						width: '160',
					},
					{
						label: '备注',
						prop: 'description',
						hide: true,
					},
				],
			},
			page: {
				pageSize: 10,
				currentPage: 1,
				total: 0,
			},
			loading: false,
			operatorModel: 'add',
			inspectTypeList: [],
			inspectTypeListTable: [],
			visible: false,
			selectionList: [],
		};
	},
	computed: {
		ids() {
			let ids = [];
			this.selectionList.forEach((ele) => {
				ids.push(ele.id);
			});
			return ids.join(',');
		},
	},
	created() {
		console.log('1111', this.projectId);
		this.initData();
	},
	watch: {
		addOrEditFlag() {
			console.log('父组件的addOrEditFlag', this.addOrEditFlag);
		},
	},
	mounted() {
		this.calcHeight();
	},
	methods: {
		// 数据导出
		exportExcel(data) {
			let saveIds = data.exportExcelSelectionRadio == '1' ? '' : this.contractIds;

			if (saveIds.length == 0 && data.exportExcelSelectionRadio == 2) {
				this.$message({
					message: '请选择需要导出的数据！',
					type: 'warning',
				});
				return;
			}
			this.$confirm('是否导出综合巡查记录数据?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				//导出数据
				let projectId = this.exportForm.projectId;

				if (data.exportExcelSelectionRadio == 2) {
					this.tool.downloadFile(
						`/api/v4ward/personal/config/export/default/taskGeneralExport?${this.website.tokenHeader
						}=${getToken()}&configExport=${data.configExport
						}&projectId=${projectId}&exportIds=${saveIds}`
					);
				} else {
					// 将条件参数拼接为路由传参格式
					let paramFormString = this.tool.objToform(this.exportForm);
					//
					this.tool.downloadFile(
						`/api/v4ward/personal/config/export/default/taskGeneralExport?${this.website.tokenHeader
						}=${getToken()}&configExport=${data.configExport}&${paramFormString}`,
						'abc.xlsx',
						'xlsx/xls'
					);
				}
			});
		},
		selectionChange(val) {
			this.selectionList = val;
			let Ids = [];
			val.forEach((element) => {
				Ids.push(element.id);
			});
			this.contractIds = Ids.join(',');
		},
		returnInspectTypeName(key) {
			let name = '';
			this.inspectTypeListTable.forEach((item) => {
				if (item.dictKey == key) {
					name = item.dictValue;
				}
			});
			return name;
		},
		recordFormClose() {
			this.visible = false;
		},
		//获取巡查类型
		async getInspectTypeList(id) {
			let data = [];
			await getBisDictData({
				projectId: id,
				code: 'project_general_inspect_type',
			}).then((res) => {
				data = res.data;
			});
			return data;
		},
		//获取部门列表
		getDeptList(value) {
			this.deptNameFlag = true;
			treeByProjectDeptId({ projectId: value }).then((res) => {
				this.deptList = res.data;
				this.deptNameFlag = false;
			});
		},
		successCallBack() {
			this.onLoad();
		},
		calcHeight() {
			this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
			this.option.height = this.bodyHeight - this.searchHeight - 279;
		},
		areaClear() {
			this.searchForm.areaName = '';
			this.searchForm.areaId = '';
		},
		deptClear() {
			this.searchForm.deptName = '';
			this.searchForm.deptId = '';
		},

		searchClear() {
			this.searchForm.objectType = '';
			this.searchForm.name = '';
			this.searchForm.deptId = '';
			this.searchForm.areaId = '';
			this.searchForm.deptName = '';
			this.searchForm.areaName = '';
			this.searchForm.fullName = '';
			this.searchForm.typeId = '';
			this.searchForm.typeName = '';
			this.searchForm.code = '';
			this.searchForm.inspectType = '';
			this.searchForm.realInspectManName = '';
			this.searchForm.errorFlag = "";
			this.searchForm.standardName = "";
			this.searchForm.errorFlag = "";
			this.searchForm.realInspectManName = "";
			this.searchForm.timeRange = [];
		},
		cancelOperate() {
			this.addOrEditFlag = false;
		},
		submitOver() {
			this.onLoad();
			this.visible = false;
		},
		removeRecord(id) {
			this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				taskGeneralRemove(id).then(() => {
					this.$message({
						type: 'success',
						message: '删除成功!',
					});
					this.onLoad();
				});
			});
		},
		editRecord(row) {
			this.recordTittle = '编辑';
			taskGeneralDetail({
				id: row.id,
			}).then((res) => {
				this.row = res.data;

				this.recordModel = 'update';
				this.visible = true;
			});
		},
		checkRecord(row) {
			this.recordTittle = '查看';
			taskGeneralDetail({
				id: row.id,
			}).then((res) => {
				this.row = res.data;

				this.recordModel = 'view';
				this.visible = true;
			});
		},
		handleClose() {
			this.form = {};
			this.addOrEditFlag = false;
		},
		searchRecord() {
			this.page.currentPage = 1;
			if (this.searchForm.timeRange && this.searchForm.timeRange.length > 0) {
				this.searchForm.startTime = this.dayjs(this.searchForm.timeRange[0]).format(
					'YYYY-MM-DD 00:00:00'
				);
				this.searchForm.endTime = this.dayjs(this.searchForm.timeRange[1]).format(
					'YYYY-MM-DD 23:59:59'
				);
			} else {
				this.searchForm.timeRange = [];
				this.searchForm.startTime = '';
				this.searchForm.endTime = '';
			}
			this.onLoad();
		},
		projectIdChange() {
			this.deptIdFlag = false;
			this.objectTypeFlag = false;

			this.searchForm.deptId = '';
			this.searchForm.areaId = '';
			this.searchForm.deptName = '';
			this.searchForm.areaName = '';
			this.searchForm.typeId = '';
			this.searchForm.typeName = '';
			this.getDeptList(this.searchForm.projectId);
			this.getInspectTypeList(this.searchForm.projectId).then((res) => {
				this.inspectTypeList = res;
			});
		},
		//添加巡检记录
		addRecord() {
			this.tool.clearObject(this.row);
			this.row.projectId = this.searchForm.projectId;
			this.recordModel = 'add';
			this.recordTittle = '新增';
			this.visible = true;
		},
		onLoad() {
			this.loading = true;
			if (this.searchForm.projectId) {
				this.getInspectTypeList(this.searchForm.projectId).then((res) => {
					this.inspectTypeListTable = res;
				});
				this.exportForm = JSON.parse(JSON.stringify(this.searchForm));
				taskListPage(
					Object.assign(
						{},
						{ current: this.page.currentPage, size: this.page.pageSize },
						this.searchForm
					)
				)
					.then(({ data }) => {
						this.data = data.records;
						this.page.total = data.total;
						this.loading = false;
					})
					.catch(() => {
						this.loading = false;
					});
			} else {
				this.loading = false;
			}
		},
		async initData() {
			await getProjectList().then((res) => {
				this.projectList = res.data;
				if (this.projectList.length > 0) {
					this.$set(this.searchForm, 'projectId', this.projectList[0].id);
					this.getDeptList(this.searchForm.projectId);
					this.getInspectTypeList(this.searchForm.projectId).then((res) => {
						this.inspectTypeList = res;
					});
				}
			});
		},
	},
};
</script>

<style scoped>
::v-deep .el-col-6 {
	height: 54px;
}

::v-deep .avue-crud__right {
	display: flex;
}
</style>
